export default __webpack_public_path__ + "static/media/basic-profile-img.bce121ad.png";